import { render, staticRenderFns } from "./WhatIDo.vue?vue&type=template&id=469076e6&scoped=true"
import script from "./WhatIDo.vue?vue&type=script&lang=ts"
export * from "./WhatIDo.vue?vue&type=script&lang=ts"
import style0 from "./WhatIDo.vue?vue&type=style&index=0&id=469076e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469076e6",
  null
  
)

export default component.exports